import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./AuthContext";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import Vacatures from "./pages/Vacatures";
import VacatureDetail from "./pages/VacatureDetail";
import AanmeldenKandidaat from "./pages/AanmeldenKandidaat";
import AanmeldenInlener from "./pages/AanmeldenInlener";
import Login from "./pages/Login";
import Uitschrijven from "./pages/Uitschrijven";
import KandidaatDashboard from "./pages/KandidaatDashboard";
import InlenerDashboard from "./pages/InlenerDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import MijnSollicitaties from "./pages/MijnSollicitaties";
import MijnOpgeslagen from "./pages/MijnOpgeslagen";
import Kenniscentrum from "./pages/Kenniscentrum";
import { OverOns, AlgemeneVoorwaarden, Privacyvoorwaarden, Cookieverklaring } from "./pages/LegalPages";

function NotFound() {
  return (
    <div className="ok-container py-24 text-center">
      <div className="ok-eyebrow">404</div>
      <h1 className="font-display text-4xl font-bold mt-3">Pagina niet gevonden</h1>
      <a href="/" className="ok-link-arrow mt-6 inline-flex">Terug naar home →</a>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/vacatures" element={<Vacatures />} />
            <Route path="/vacature/:id" element={<VacatureDetail />} />
            <Route path="/aanmelden-kandidaat" element={<AanmeldenKandidaat />} />
            <Route path="/aanmelden-inlener" element={<AanmeldenInlener />} />
            <Route path="/login" element={<Login />} />
            <Route path="/uitschrijven" element={<Uitschrijven />} />
            <Route path="/over-ons" element={<OverOns />} />
            <Route path="/kenniscentrum" element={<Kenniscentrum />} />
            <Route path="/algemene-voorwaarden" element={<AlgemeneVoorwaarden />} />
            <Route path="/privacyvoorwaarden" element={<Privacyvoorwaarden />} />
            <Route path="/cookieverklaring" element={<Cookieverklaring />} />
            <Route path="/kandidaat-dashboard" element={
              <ProtectedRoute roles={["candidate"]}><KandidaatDashboard /></ProtectedRoute>
            } />
            <Route path="/mijn-sollicitaties" element={
              <ProtectedRoute roles={["candidate"]}><MijnSollicitaties /></ProtectedRoute>
            } />
            <Route path="/mijn-opgeslagen" element={
              <ProtectedRoute roles={["candidate"]}><MijnOpgeslagen /></ProtectedRoute>
            } />
            <Route path="/inlener-dashboard" element={
              <ProtectedRoute roles={["client"]}><InlenerDashboard /></ProtectedRoute>
            } />
            <Route path="/admin" element={
              <ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>
            } />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
